import { render, staticRenderFns } from "./MainPayService.vue?vue&type=template&id=820caeae&scoped=true&"
import script from "./MainPayService.vue?vue&type=script&lang=ts&"
export * from "./MainPayService.vue?vue&type=script&lang=ts&"
import style0 from "./MainPayService.vue?vue&type=style&index=0&id=820caeae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820caeae",
  null
  
)

export default component.exports